import React from 'react';
import PropTypes from 'prop-types';
import pluralize from 'pluralize';
import ToolTipIcon from '../../../components/ToolTipIcon/ToolTipIcon';
import ToolTip from '../../../components/ToolTipIcon/ToolTip';

function TierActions(props) {
  const {
    handleClickEdit,
    handleClickDelete,
    handleClickAdd,
    handleClickUpload,
    selectedItemsLength,
  } = props;
  const {
    auth: {
      user: {
        permissions: { Writer },
      },
    },
  } = props;

  if (!Writer) {
    return [];
  }

  return (
    <div
      data-test="Tier-Actions"
      className="grid grid-cols-[repeat(5,_max-content)] md:grid-cols-[repeat(7,_max-content)] xl:grid-cols-[repeat(14,_max-content)] gap-2 mt-8"
    >
      <ToolTip className="add-btn" toolText="Add Row">
        <button
          type="button"
          onClick={handleClickAdd}
          className="duration-500 hover:scale-105 w-[50px] cursor-pointer h-[50px] flex justify-center items-center rounded-lg"
        >
          <img
            src="/assets/images/icons/upload_icon.svg"
            alt="Health Check"
            className="w-[50px] h-[50px]"
          />
        </button>
      </ToolTip>
      <ToolTip toolText="Update Tier from CSV File">
        <div className="flex items-center justify-center flex-col">
          <button
            type="button"
            data-test="content-selector-upload-file"
            className="duration-500 hover:scale-105 w-[50px] text-[#0A364B] cursor-pointer h-[50px] flex justify-center items-center bg-white rounded-lg"
            onClick={handleClickUpload}
          >
            <img
              src="/assets/images/icons/file_upload.svg"
              alt="desktop icon"
              className="w-[30px] h-[30px]"
            />
          </button>
        </div>
      </ToolTip>
      {selectedItemsLength > 0 && (
        <ToolTipIcon toolText={pluralize('Delete Row', selectedItemsLength)}>
          <button
            type="button"
            onClick={handleClickDelete}
            className="duration-500 hover:scale-105 w-[50px] cursor-pointer h-[50px] flex justify-center items-center bg-white rounded-lg"
          >
            <img
              src="/assets/images/icons/delete_button.svg"
              alt="Delete"
              className="w-[30px] h-[30px]"
              draggable={false}
            />
          </button>
        </ToolTipIcon>
      )}

      {selectedItemsLength === 1 && (
        <ToolTipIcon toolText="Edit Row">
          <button
            type="button"
            onClick={handleClickEdit}
            className="duration-500 hover:scale-105 w-[50px] cursor-pointer h-[50px] flex justify-center items-center bg-white rounded-lg"
          >
            <img
              src="/assets/images/icons/pencil_button.svg"
              alt="Edit"
              className="w-[30px] h-[30px]"
              draggable={false}
            />
          </button>
        </ToolTipIcon>
      )}
    </div>
  );
}

TierActions.propTypes = {
  handleClickEdit: PropTypes.func.isRequired,
  selectedItemsLength: PropTypes.number,
  getSelectedItems: PropTypes.func.isRequired,
  handleClickDelete: PropTypes.func,
  handleClickUpload: PropTypes.func,
  handleClickAdd: PropTypes.func,
  auth: PropTypes.shape({
    user: PropTypes.shape({
      permissions: PropTypes.shape({
        Writer: PropTypes.bool,
      }),
    }),
  }).isRequired,
};

export default TierActions;
